import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    meta: {
      layout: 'auth',
    },
    component: () => import('../views/Auth/Login/Login.vue'),
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    meta: {
      layout: 'auth',
    },
    component: () => import('../views/Auth/ForgotPassword/ForgotPassword.vue'),
  },
  {
    path: '/reset-password/:token',
    name: 'reset-password',
    meta: {
      layout: 'auth',
    },
    component: () => import('../views/Auth/NewPassword/NewPassword.vue'),
  },
  {
    path: '/registration',
    name: 'registration',
    meta: {
      layout: 'auth',
    },
    component: () => import('../views/Auth/Registration/Registration.vue'),
  },
  {
    path: '/',
    name: 'dashboard',
    meta: {
      layout: 'main',
      requiresAuth: true,
    },
    component: () => import('../views/Accruals/Accruals.vue')
  },
  {
    path: '/payments',
    name: 'payments',
    meta: {
      layout: 'main',
      requiresAuth: true,
    },
    component: () => import('../views/Payments/Payments.vue')
  },
  {
    path: '/accruals',
    name: 'accruals',
    meta: {
      layout: 'main',
      requiresAuth: true,
    },
    component: () => import('../views/Accruals/Accruals.vue')
  },
  {
    path: '/indicators',
    name: 'indicators',
    meta: {
      layout: 'main',
      requiresAuth: true,
    },
    component: () => import('../views/Indicators/Indicators.vue')
  },
  {
    path: '/network-join',
    name: 'network-join',
    meta: {
      layout: 'main',
      requiresAuth: true,
      managerOnly: true
    },
    component: () => import('../views/NetworkJoinApplication/NetworkJoinApplication.vue')
  },
  {
    path: '/users',
    name: 'users',
    meta: {
      layout: 'admin',
      requiresAuth: true,
      adminOnly: true,
    },
    component: () => import('../views/Users/Users.vue')
  },
  {
    path: '/policy',
    name: 'policy',
    meta: {
      layout: 'empty',
      requiresAuth: false,
    },
    component: () => import('../views/Policy/Policy.vue')
  },
  {
    path: '/join',
    name: 'join',
    meta: {
      layout: 'base',
      requiresAuth: false,
    },
    component: () => import('../views/Join/Join.vue')
  },
  {
    path: '/applications',
    name: 'applications',
    meta: {
      layout: 'admin',
      requiresAuth: true,
      managerOnly: true,
    },
    component: () => import('../views/Applications/Applications.vue')
  },
  {
    path: '/survey/entry',
    name: 'survey-entry',
    meta: {
      layout: 'base',
      requiresAuth: false,
    },
    component: () => import('../views/Survey/SurveyEntry.vue')
  },
  {
    path: '/survey/household',
    name: 'survey-household',
    meta: {
      layout: 'base',
      requiresAuth: false,
    },
    component: () => import('../views/Survey/SurveyEntry.vue')
  },
  {
    path: '/survey/non-household',
    name: 'survey-non-household',
    meta: {
      layout: 'base',
      requiresAuth: false,
    },
    component: () => import('../views/Survey/SurveyEntry.vue')
  },
  {
    path: '/survey/:id',
    name: 'survey-form',
    meta: {
      layout: 'base',
      requiresAuth: false,
    },
    component: () => import('../views/Survey/SurveyForm.vue')
  },
  {
    path: '/survey',
    name: 'survey-user',
    meta: {
      layout: 'main',
      requiresAuth: true,
    },
    component: () => import('../views/Survey/SurveyForm.vue')
  },
  {
    path: '/admin/surveys',
    name: 'admin-surveys',
    meta: {
      layout: 'admin',
      requiresAuth: true,
      managerOnly: true,
    },
    component: () => import('../views/AdminSurvey/AdminSurveys.vue')
  },
  {
    path: '/admin/survey-results',
    name: 'admin-survey-results',
    meta: {
      layout: 'admin',
      requiresAuth: true,
      managerOnly: true,
    },
    component: () => import('../views/AdminSurvey/AdminSurveyResults.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
  const isTmgaz = store.getters.isTmgaz;
  const isLocalhost = store.getters.isLocalhost;
  const isSurveyAllowed = isTmgaz || isLocalhost;

  // Restrict all survey routes (public survey & admin survey) to tmgaz.te.ua and localhost
  const isSurveyRoute = to.path.startsWith('/survey') || to.path.startsWith('/admin/survey');
  if (isSurveyRoute && !isSurveyAllowed) {
    if (store.getters.isLoggedIn) {
      next('/');
    } else {
      next('/login');
    }
    return;
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      if (store.getters.isUser && (to.matched.some(record => record.meta.adminOnly) || to.matched.some(record => record.meta.managerOnly))) {
        next('/');
      }
      if (store.getters.isManager && !to.matched.some(record => record.meta.managerOnly) && !isTmgaz) {
        next('/applications')
      }
      if (store.getters.isManager && !to.matched.some(record => record.meta.managerOnly) && isTmgaz) {
        next('/network-join')
      }
      next()
      return
    }
    // If not logged in and navigating to /survey (on tmgaz or localhost), redirect to public survey entry
    if (to.path === '/survey') {
      next({ path: '/survey/entry', query: to.query })
      return
    }
    next('/login')
  } else {
    next()
  }
})

export default router
